import { render, staticRenderFns } from "./InfoStatistics.vue?vue&type=template&id=66175eac"
import script from "./InfoStatistics.vue?vue&type=script&lang=js"
export * from "./InfoStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports